import { myAccountViewStyles } from "@waytek/Overrides/Widgets/MyAccount/MyAccountView";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

myAccountViewStyles.quickLinksGridItem = {
    ...myAccountViewStyles.quickLinksGridItem,
    css: css`
        ${mediaQueriesBP.minLG} {
            padding-top: 40px;
        }

        ${mediaQueriesBP.maxLG} {
            padding-top: 20px;
        }
    `,
};
